import React, {useState, useEffect,  useRef} from 'react'
import {LoadEffect}  from '../component/loader'
import axios from 'axios'
import {Alerts } from '../component/notify'
import PageHeader from '../component/pageheader'
import {ServerUrl,  Token, FormatNumber, Currency, config, API_URL} from '../component/include'
import Select from 'react-select'
import { formatGroupLabel} from '../component/globalFunction'


import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

 const Transfer =()=> {
    const structure = useRef(null)
    const [errors, setErrors] = useState({});
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    });
    

    const schoolClass  = useSelector(state => state.rootReducer.schoolClass);
 const [examtype, setExamtype]=useState([])
    const [feecharge, setFeecharge] = useState([]);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [students, setStudents] = useState([]);  
const [studentTransfer, setStudentTransfer]= useState({
        feecharge:"",
        remark:'',
        feeStructure:'',
        fromClass:[],
        examtype:[],
         toClass:[],
         student:[],
})




const fetchExamType =()=>{
    var sql ="SELECT CONCAT(t.session, ' ', t.term) as exam, t.term, r.examCode  from tbl_exam_result r, tbl_exam_type t where r.examCode = t.code  group by r.examCode order by exam ASC" ;


const fd = new FormData();
fd.append("sql", sql);
fd.append('jwt', Token);
let url = ServerUrl+'/fetchBySql_controller';
axios.post(url, fd, config).then(result=>{
setExamtype(result.data)
})
.catch((error)=>{
Alerts('Error!', 'danger', error.message)
})
}


    const fetchFeecharge =()=>{
        const fd = new FormData();
    fd.append("jwt", Token);
        let url = ServerUrl+'/fetch_controller/tbl_fees_charge'
        axios.post(url, fd, config).then(result=>setFeecharge(result.data))
    }
    



        const handleSelect = (option, action)=>{
            setStudentTransfer({...studentTransfer, [action.name]: option});
            setErrors({...errors, [action.name]:''})
             }

             const  handleStudents =(section)=>{  
                setNotice({...notice,  isLoading: true });
                let url = API_URL+'/student/section/'+section;
                axios.get(url,  config).then(result=>{
                    if(result.data.data.length!==0){
                        setStudents(result.data.data)
                    }else{
                        setStudents([])
                    }
                })
                .catch((error)=>{
                    Alerts('Error!', 'danger', error.message)
                }).finally(()=>{
                    setNotice({...notice,  isLoading: false });
                })
                
                 }


             const handleSelectFrom = (option, action)=>{
                setStudentTransfer({...studentTransfer, [action.name]: option});
                 handleStudents(option.value);
                 setErrors({...errors, [action.name]:''})
             }


             const handleSelectTo = (option, action)=>{
                setStudentTransfer({...studentTransfer, [action.name]: option
                });
                setErrors({...errors, [action.name]:''})
                 }

  

 const handleSubmit = event =>{
    event.preventDefault();
    setErrors(ValidateInput(studentTransfer)); 
    setIsSubmitting(true);
} 



const ValidateInput =(values)=>{
	let errors = {};   
        
    if(values.fromClass.value === values.toClass.value ){
        errors.toClass ='Same Class Section selected, kindly change class section to be transfer to ';
    }

    if(values.toClass.length===0){
        errors.toClass ='Please select to Class';
	}
    if(values.fromClass.length===0){
        errors.fromClass ='Please select current Class ';
        window.scrollTo(0,0);
    }
    if(students.length===0){
        errors.student ='There are no student in the selected class ';
        window.scrollTo(0,0);
    } 

    if(values.student.length===0){
        errors.student ='Please select student to transfer';
        window.scrollTo(0,0);
    }
    
    
    return errors;
	}
	
	

function submit(){ 
    
     setNotice({...notice, isLoading: true}) 

     let examtype = studentTransfer.examtype.map((list, idx)=> {
        return list.value
     })


      const fd = new FormData(); 
    fd.append("jwt", Token);
    fd.append('to_classId', studentTransfer.toClass.classID);
        fd.append('to_sectionId', studentTransfer.toClass.value);
        fd.append('examtype', JSON.stringify(examtype, null, 2));
        fd.append('from_sectionId', studentTransfer.fromClass.value);
        fd.append('students', JSON.stringify(studentTransfer.student, null, 2));
        if(studentTransfer.feecharge.label){
        fd.append('feecharge', studentTransfer.feecharge.value);
        }
    let url = API_URL+'/student/transfer'
     
	  axios.post(url, fd, config)
	  .then(response =>{


		if (response.data.status ===200){
			Alerts('Saved!', 'success', response.data.message)
		} else{
			setErrors({...errors, errorMessage: JSON.stringify(response.data)})
	}  
	})
	.catch((error)=>{
        setErrors({...errors, errorMessage: JSON.stringify(error.message)})
	})
	.finally(()=>{
	  setNotice({...notice, isLoading: false}) 
      setIsSubmitting(false); 
      setStudentTransfer({
          toClass:[],
          feecharge:[],
          fromClass:[],
          student:[],
    });
})  
}

useEffect(()=>{
    if(Object.keys(errors).length === 0 && isSubmitting){
    submit()
    }
    },[errors])


       
   

        useEffect(()=>{
            fetchExamType()
            fetchFeecharge()
		},[]);
        
        return ( <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Transfer Student">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-home"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><Link to="/students/view_students"> Students</Link></li> 
                    <li className="breadcrumb-item"><a href="#!">Transfer Student</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
<div className="page-body">
								

                                
{errors.errorMessage?
<div className="alert alert-danger background-danger">
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
            <i className=" fa fa-times text-white"></i>
        </button>
        <strong> {errors.errorMessage}</strong> 
    </div>:''}


								<div className="row  ">
								<div className="col-sm-12">
	<div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit"></i> Transfer From Class To Class</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather minimize-card icon-minus"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div>
		<div className="card-block" >
		<fieldset>
        <div className="row">
<div className="col-sm-12">

				
	<div className="card z-depth-0">
										<section className="card-block">


                          
           <div className="form-group">
         <label> Transfer Exam Type </label>
         <Select  options={examtype&&examtype.map((list, idx)=> {
                               return {key:idx, value: list.examCode, label: list.exam, term: list.term }
                             })
                        } 
                       isMulti
onChange={handleSelect} className={errors.examtype ? 'form-control form-control-danger' : ''} name="examtype" value={studentTransfer.examtype}  /> 

            </div>
            {studentTransfer.examtype.length>0 &&   (
<div className='alert alert-success '>

    <p> If <b>Selected Exam Type</b> exist for the selected student, the exam mark will be move to new class </p>

</div>
)} 


										
	<div className="form-group">
	
	<label >Fee Charge  </label>
	<Select  options={feecharge&&feecharge.map((list, idx)=> {
								   return {key:idx, value: list.code, label:list.feesCharge, session:list.sessionCode }
								 })
							} 
							getOptionLabel={option =>`${option.session}  ${option.label}`}       
	onChange={handleSelect} name="feecharge" value={studentTransfer.feecharge} className={errors.feecharge ? 'form-control form-control-danger' : ''}  /> 
	<span style={{color:'red'}}>{errors.feecharge && errors.feecharge}</span>
				</div>

{studentTransfer.feecharge.label &&   (
<div className='alert alert-success '>

    <p> If <b>{studentTransfer.feecharge.label}</b> exist for the selected student, such fees will be move to new class </p>

</div>
)} 




					<div className="form-group">
						<label>Current Class</label>
						<Select  options={
                            schoolClass.map((list, idx)=> {
                               return {key:idx, value: list.ID, label: list.cname, options:list.section.map((sec, id)=>{ 
                                   return sec.sname !==''? {key:id, classID:list.ID,isSection:'1', value: sec.ID, label: sec.sname}:{classID:list.ID, value: list.ID, label: list.cname, isSection:'0'}
                               }) }
                             })
                        } 
                        formatGroupLabel={formatGroupLabel}
onChange={handleSelectFrom} className={errors.fromClass ? 'form-control form-control-danger' : ''} name="fromClass" value={studentTransfer.fromClass}  /> <span style={{color:'red'}}>{errors.fromClass && errors.fromClass}</span>
</div>

	<div className="form-group">
						<label>Student</label>
						<Select  
                        
                        isMulti
                        
                        options={
                            students&&students.map((list, idx)=> {
                               return {key:idx, value: list.code, label: list.admissionNumber, studentName:list.studentName, co:list.fatherName, phone:list.father_mobile  }
                             })} 
                        getOptionLabel={option =>`(${option.label}) ${option.studentName} C/O  ${option.co}  ${option.phone}`}
onChange={handleSelect} className={errors.student ? 'form-control form-control-danger' : ''} name="student" value={studentTransfer.student}  /> <span style={{color:'red'}}>{errors.student && errors.student}</span>
											</div>
											
                                            
                                            
                 <div className="form-group">
						<label>To Class</label>
						<Select  options={
                            schoolClass.map((list, idx)=> {
                               return {key:idx, value: list.ID, label: list.cname, options:list.section.map((sec, id)=>{ 
                                   return sec.sname !==''? {key:id, classID:list.ID,isSection:'1', value: sec.ID, label: sec.sname}:{classID:list.ID, value: list.ID, label: list.cname, isSection:'0'}
                               }) }
                             })
                        } 
                        formatGroupLabel={formatGroupLabel}
onChange={handleSelectTo} className={errors.toClass ? 'form-control form-control-danger' : ''} name="toClass" value={studentTransfer.toClass}  /> <span style={{color:'red'}}>{errors.toClass && errors.toClass}</span>
												
										</div>
		</section></div></div>
                                        
                                        
                                        </div>
                                   
								</fieldset>

	<footer className="pull-right">
	
	<button type="button" id="submit" onClick={handleSubmit} className="btn btn-primary "><i className="fa fa-refresh"></i> Confirm Transfer</button>
	
								</footer>				
							</div>
							</div>
							</div>
	                   
                            </div>

                </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(Transfer) 